export function isMetuchenAdmin() {
    return window.cccisd.fortress.hasAccess('quest.view_data', 91);
}
